var map = {
	"./back.svg": 59,
	"./banner_placeholder1.png": 99,
	"./banner_placeholder2.png": 100,
	"./bg.jpg": 101,
	"./bg.png": 60,
	"./cart.png": 51,
	"./category_placeholder.png": 61,
	"./error.png": 62,
	"./non_veg_icon.png": 38,
	"./veg_icon.png": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;